import { saveRUCInfoActions,getESignActions,saveESignActions } from "./action";

const initialState = {
  rucInfoData: null,
  saveEsign:null,
  getEsign:{}
};

const saveRucInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveRUCInfoActions.SAVE_RUC_INFO_EDITPARTNER_SUCCESS:
      return {
        ...state,
        PanTerucInfoDataamVerify: action.payload.data,
      };
    case saveRUCInfoActions.SAVE_RUC_INFO_EDITPARTNER_ERROR:
      return {
        ...state,
        rucInfoData: [],
      };


      case getESignActions.GET_ESIGN_DATA_SUCCESS:
        return {
        
          ...state,
          getEsign: action.payload,
          error: "",
        };
      case getESignActions.GET_ESIGN_DATA_ERROR:
        return {
         
          ...state,
          getEsign: {},
          error:action.payload
        };

        case saveESignActions.SAVE_ESIGN_TIGGER_SUCCESS:
          return {
          
            ...state,
            saveEsign: action.payload,
            error: "",
          };
        case saveESignActions.SAVE_ESIGN_TIGGER_ERROR:
          return {
           
            ...state,
            saveEsign: {},
            error:action.payload
          };


    default:
      return state;
  }
};

export default saveRucInfoReducer;
